import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import HeroSection from "./components/HeroSection";
import LatestGossipSection from "./components/LatestGossipSection";
import HotRankingSection from "./components/HotRankingSection";
import EncyclopediaSection from "./components/EncyclopediaSection";

export default function Home() {
  return (
    <>
      <Navbar />
      <main>
        <HeroSection />
        <LatestGossipSection />
        <HotRankingSection />
        <EncyclopediaSection />
      </main>
      <Footer />
    </>
  );
}